import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./admin/AuthContext";
import ProtectedRoute from "./admin/ProtectedRoute";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Industries from "./components/Industries";
import Process from "./components/Process";
import ServiceModels from "./components/ServiceModels";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Marquee from "./components/Marquee";
import LegalPage from "./pages/LegalPage";
import AdminLayout from "./pages/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminInquiries from "./pages/admin/AdminInquiries";
import AdminServiceModels from "./pages/admin/AdminServiceModels";
import AdminContactInfo from "./pages/admin/AdminContactInfo";
import "./App.css";

function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#fafbfd] text-[#0A0A0A]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Industries />
        <Process />
        <ServiceModels />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            theme="light"
            toastOptions={{
              className: "font-mono-tech",
              style: {
                borderRadius: 0,
                border: "1px solid #1d428a",
                background: "#fff",
                color: "#0A0A0A",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<LegalPage kind="impressum" />} />
            <Route path="/datenschutz" element={<LegalPage kind="datenschutz" />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="inquiries" element={<AdminInquiries />} />
              <Route path="models" element={<AdminServiceModels />} />
              <Route path="contact-info" element={<AdminContactInfo />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
